import { render, staticRenderFns } from "./ClmOpsNaoPossuiHistorico.vue?vue&type=template&id=2ce9dde6"
import script from "./ClmOpsNaoPossuiHistorico.vue?vue&type=script&lang=js"
export * from "./ClmOpsNaoPossuiHistorico.vue?vue&type=script&lang=js"
import style0 from "./ClmOpsNaoPossuiHistorico.vue?vue&type=style&index=0&id=2ce9dde6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports